namespace GeniuzPOS.InitialData {
    export namespace PsCorperateMessageRecieptService {
        export const baseUrl = 'InitialData/PsCorperateMessageReciept';

        export declare function Create(request: Serenity.SaveRequest<PsCorperateMessageRecieptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsCorperateMessageRecieptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsCorperateMessageRecieptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsCorperateMessageRecieptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsCorperateMessageReciept/Create",
            Update = "InitialData/PsCorperateMessageReciept/Update",
            Delete = "InitialData/PsCorperateMessageReciept/Delete",
            Retrieve = "InitialData/PsCorperateMessageReciept/Retrieve",
            List = "InitialData/PsCorperateMessageReciept/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsCorperateMessageRecieptService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
